import axios from "axios";
import { z } from "zod";
import { environment } from "../../../environment";
import { errorLog } from "../../../logger";
import { ClientId } from "../../Types";
import ValidationError from "../../ZodError";
const AdvisorRole = z.object({
    id: z.number(),
    displayName: z.string(),
    description: z.string(),
});
const Client = z.object({
    clientId: ClientId,
    email: z.string(),
    name: z.object({
        prefix: z.string().nullable(),
        first: z.string(),
        middle: z.string().nullable(),
        last: z.string(),
        suffix: z.string().nullable(),
    }),
});
const Response = z.object({
    isAdmin: z.boolean(),
    advisorRoles: AdvisorRole.array(),
    clients: Client.array(),
});
export const url = (advisorId) => environment() === "PROD"
    ? `https://middleware.prod.farther.com/dashboard/advisor/${advisorId}`
    : `https://middleware.uat.farther.com/dashboard/advisor/${advisorId}`;
export default async function getAdvisorInfo(advisorId, config) {
    const res = await axios.get(url(advisorId), {
        headers: {
            Authorization: `Bearer ${config.jwt}`,
            Advisor: config.advisorId,
        },
    });
    const decoded = Response.safeParse(res.data);
    if (decoded.success) {
        return decoded.data;
    }
    else {
        const errorMessage = "Could not decode advisor info response";
        errorLog("AdvisorInfo", `${decoded.error.message} ${JSON.stringify(decoded.error.issues)}`);
        throw new ValidationError(errorMessage, decoded.error.issues);
    }
}
//# sourceMappingURL=getAdvisorInfo.js.map